import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { PersonOutlined, LogoutOutlined } from '@mui/icons-material';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onToggleMenu } from 'redux/actions/app.actions';
import { onLogout, onLogoutPublic } from 'redux/actions/auth.actions';
import { userSelector } from 'redux/selectors/auth.selector';
import { history } from 'helpers/history';

import Navbar from 'components/main/Navbar';

import 'components/main/Navbar/i18n';

export interface INavbarContainerProps {
  isPublic: boolean;
  isMobile: boolean;
  title: string;
  isVerified?: boolean;
  onTitleClick?: () => void;
}

const NavbarContainer: FunctionComponent<INavbarContainerProps> = (
  props: INavbarContainerProps,
) => {
  const { isMobile, isPublic, title, isVerified, onTitleClick } = props;
  const dispatch = useDispatch();
  const user = useTypedSelector(userSelector);
  const initials = user ? `${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}` : '';

  const onOpenMenu = () => dispatch(onToggleMenu(true));

  const onLogoutClick = () => dispatch(onLogout());

  const onLogoutPublicClick = () => dispatch(onLogoutPublic());

  const items = [
    {
      Icon: PersonOutlined,
      key: 'edit-profile',
      label: i18next.t<string>('NAVBAR:EDIT_PROFILE'),
      onClick: () => history.push(`/users/${user?.id}/edit`),
    },
    {
      Icon: LogoutOutlined,
      key: 'log-out',
      label: i18next.t<string>('NAVBAR:LOG_OUT'),
      onClick: onLogoutClick,
    },
  ];

  return (
    <Navbar
      initials={initials}
      isMobile={isMobile}
      isPublic={isPublic}
      items={items}
      onLogoutPublicClick={onLogoutPublicClick}
      onOpenMenu={onOpenMenu}
      title={title}
      isVerified={isVerified}
      onTitleClick={onTitleClick}
    />
  );
};

export default NavbarContainer;
